import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";
import { StyledButton } from "./style";
import styled from "styled-components";
import usePostReEntryIncrease from "entity/timer/usePostReEntryIncrease";
import usePostReEntryDecrease from "entity/timer/usePostReEntryDecrease";

const ReEntryButton = ({ type, reEntryList, label = "" }) => {
  const [reEntryIncrease] = usePostReEntryIncrease();
  const [reEntryDecrease] = usePostReEntryDecrease();

  function handleClick(info) {
    if (!reEntryList || reEntryList?.length === 0) return;
    const selected = reEntryList[info.key];
    if (type === "increase") {
      reEntryIncrease(selected);
    } else {
      reEntryDecrease(selected);
    }
  }
  const menu = (
    <Menu style={{ padding: "6px 16px" }} onClick={handleClick}>
      {reEntryList?.length > 0 ? (
        <>
          {reEntryList.map((item, index) => (
            <StyledMenuItem
              style={{ padding: "6px 16px", fontSize: "12px" }}
              key={index}
            >
              {item}
            </StyledMenuItem>
          ))}
        </>
      ) : (
        <StyledMenuItem disabled>리엔트리 데이터가 없습니다.</StyledMenuItem>
      )}
    </Menu>
  );

  return (
    <Dropdown
      trigger={["hover"]}
      overlay={menu}
      animation="slide-up"
      overlayStyle={{ width: "fit-content" }}
    >
      <StyledButton fitWidth small>
        {label}
      </StyledButton>
    </Dropdown>
  );
};

export default ReEntryButton;

const StyledMenuItem = styled(MenuItem)`
  padding: 6px 16px;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    color: #ed3241 !important;
    background-color: #fff !important;
  }
  &.rc-menu-item-selected {
    background-color: #fff !important;
  }
`;
